/** @format */

import useAvailability from '@/@ducks/cardRoom/hooks/useAvailability';
import { selectorAvailabilityRoom } from '@/@ducks/shared/selectors';
import CalendarIcon from '@/assets/icons/card-room-calendar-icon.svg';
import { Icon } from '@/components/ui/Icon';
import { useAppTranslation } from '@/i18n/declarations';
import { useAppSelector } from '@/redux/hooks';
import React from 'react';
import { AvailabiltyStatus, IconWrapper, Wrapper } from './Availability.style';
import { LoadingSpinner } from './LoadingSpinner';

const Availability: React.FC<AvailabilityProps> = React.memo(({ bedCode, availableFrom, isLoading = true }) => {
  const roomAvailability = useAppSelector(store => selectorAvailabilityRoom(store, bedCode ?? ''));
  const { availabilityText } = useAvailability({ availableFrom, roomAvailability });
  const { t } = useAppTranslation();

  return (
    <Wrapper>
      <IconWrapper>
        <Icon icon={CalendarIcon} color="#667085" width={16} height={16} />
        <span>{t('available')}</span>
      </IconWrapper>
      <AvailabiltyStatus>{isLoading ? <LoadingSpinner /> : availabilityText}</AvailabiltyStatus>
    </Wrapper>
  );
});

export default Availability;

interface AvailabilityProps {
  isLoading?: boolean;
  availableFrom?: string;
  bedCode?: string;
}
